<template>
  <div class="col-md-12">
    <div v-if="currentSale" class="card card-container">
      <h4><font-awesome-icon icon="edit" /> Edit Sale Details</h4>
      <form name="form" @submit.prevent="updateSale">
        <div v-if="!successful">
          <div class="form-group">
            <label for="products">Product: </label>
            <select v-model="currentSale.productId" @change="onChangeProduct($event)" v-validate="'required'" class="form-control" id="products" name="products">
              <option v-for="product in products" v-bind:value="product.id" :key="product.id" :id="product.pv" :selected="product.id === currentSale.productId ? true : false">{{ product.name }}</option>
            </select>
            <div v-if="submitted && errors.has('products')" class="alert-danger">{{errors.first('products')}}</div>
          </div>
          <div class="form-group">
            <label for="quantity">Quantity:</label>
            <input v-model="currentSale.quantity" v-validate="'required|min:1|max:6'" type="number" class="form-control" id="quantity" name="quantity"/>
            <div v-if="submitted && errors.has('quantity')" class="alert-danger" >{{errors.first('quantity')}}</div>
          </div>
          <div class="form-group">
            <label for="soldDate">Sold Date:</label>
            <input v-model="currentSale.soldDate" v-validate="'required|min:10|max:10'" type="date" class="form-control" id="soldDate" name="soldDate"/>
            <div v-if="submitted && errors.has('soldDate')" class="alert-danger" >{{errors.first('soldDate')}}</div>
          </div>
          <!-- <div class="form-group">
            <label for="members">Member: </label>
            <select v-model="currentSale.memberId" @change="onChangeMember($event)" v-validate="'required|min:9|max:12'" class="form-control" id="members" name="members">
              <option v-for="member in members" v-bind:value="member.id" :key="member.id" :selected="member.id === currentSale.memberId ? true : false">{{ member.id }} ({{ member.surname }}, {{ member.first_name }})</option>
            </select>
            <div v-if="submitted && errors.has('members')" class="alert-danger">{{errors.first('members')}}</div>
          </div> -->
          <div class="form-group">
            <label for="memberId">Member:</label>
            <input v-model="currentSale.memberId" v-validate="'required|min:9|max:12'" type="number" class="form-control" id="memberId" name="memberId"/>
            <div v-if="submitted && errors.has('memberId')" class="alert-danger" >{{errors.first('memberId')}}</div>
          </div>
          
          <div class="form-group">
            <button class="badge badge-danger mr-2" @click="deleteSale"><font-awesome-icon icon="trash-alt" /> Delete</button>
            <button type="submit" class="badge badge-success mr-2"><font-awesome-icon icon="save" /> Update</button>
            <button class="badge badge-primary" @click="salesList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      <div v-if="message && successful">
        <button class="btn btn-primary" @click="salesList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
      </div>
    </div>
    <div v-else>
      <br />
      <p>Please click on a Sale...</p>
    </div>
  </div>
</template>

<script>
import SaleService from "../services/sale.service";
import MemberService from "../services/member.service";
import ProductService from "../services/product.service";

export default {
  name: 'sale',
  data() {
    return {
      currentSale: null,
      submitted: false,
      successful: false,
      message: '',
      members: [],
      products: [],
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    getSale(id) {
      SaleService.get(id)
        .then(response => {
          this.currentSale = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    retrieveMembers() {
      MemberService.getAll()
        .then(response => {
          this.members = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    onChangeMember: function(e) {
      this.currentSale.memberId = e.target.value;
    },

    retrieveProducts() {
      ProductService.getAll()
        .then(response => {
          this.products = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    onChangeProduct: function(e) {
      this.currentSale.productId = e.target.value.id;
      this.currentSale.pv = event.target.options[event.target.options.selectedIndex].id;
    },
    
    /*updateSale() {
      this.currentSale.totalPv = this.currentSale.pv * this.currentSale.quantity;
      this.message = '';
      this.submitted = true;
      this.$validator.validate().then(isValid => {
        if (isValid) {
          SaleService.update(this.currentSale.id, this.currentSale).then(
            response => {
              console.log(response.data);
              this.message = 'The sale was updated successfully!';
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log(e);
            });
        }
      });
    },*/

    updateSale() {
      MemberService.memberExist(this.currentSale.memberId)
        .then(response => {
          let memberExistRes = response.data;
          //console.log(response.data);
          if(memberExistRes <= 0){
            this.message = 'Invalid Member ID!';
            this.successful = false;
          }
          else{
            this.currentSale.totalPv = this.currentSale.pv * this.currentSale.quantity;
            this.message = '';
            this.submitted = true;
            this.$validator.validate().then(isValid => {
              if (isValid) {
                SaleService.update(this.currentSale.id, this.currentSale).then(
                  response => {
                    console.log(response.data);
                    this.message = 'The sale was updated successfully!';
                    this.successful = true;
                  },
                  error => {
                    this.message = (error.response && error.response.data) || error.message || error.toString();
                    this.successful = false;
                  })
                  .catch(e => {
                    console.log(e);
                  });
              }
            });

          }

        })
        .catch(e => {
          console.log(e);
        });

    },

    deleteSale() {
      SaleService.delete(this.currentSale.id)
        .then(response => {
          console.log(response.data);
          this.$router.push({ name: "sales" });
        })
        .catch(e => {
          console.log(e);
        });
    },

    salesList() {
      this.$router.push('/sales');
    }
  },
  mounted() {
    this.message = '';
    this.getSale(this.$route.params.id);
    //this.retrieveMembers();
    this.retrieveProducts();
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>